/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Contact_Sales_BodyInputs */

const en_platform_contact_sales_body = /** @type {(inputs: Platform_Contact_Sales_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not sure it fits how you work? Tell us about your week and we will say honestly.`)
};

const pl_platform_contact_sales_body = /** @type {(inputs: Platform_Contact_Sales_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie wiesz, czy to pasuje do Twojej pracy? Opowiedz o swoim tygodniu, a powiemy szczerze.`)
};

/**
* | output |
* | --- |
* | "Not sure it fits how you work? Tell us about your week and we will say honestly." |
*
* @param {Platform_Contact_Sales_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_contact_sales_body = /** @type {((inputs?: Platform_Contact_Sales_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Contact_Sales_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_contact_sales_body(inputs)
	return en_platform_contact_sales_body(inputs)
});